import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en = {
  ...i18n_en,
  ...enLocale
}

export default en;